import { cn } from '~/lib'

export default function PulseDot({ className }: { className?: string }) {
  return (
    <span className={cn('relative inline-flex h-2.5 w-2.5', className)}>
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-75"></span>
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary"></span>
    </span>
  )
}
